import Widget from 'models/dashboard/widget'

Widget.TagSourceDistributionPieWidget = Widget.extend({
  tagIds: function () {
    return this.get('tag_ids');
  }
});
export default Widget.TagSourceDistributionPieWidget;

